export default __webpack_public_path__ + "static/media/STRESS_black.49c0b30c.svg";